import React, { useState, useMemo } from "react";
import RestaurantCard from "./card";
import RestaurantAd from "./ad";
import "./index.less";
import { useRequest } from "ahooks";
import { useLocation } from "react-router-dom";
import { getQuery } from "@/service/http";
import { useStores } from "@/store";
import Skeleton from "@/ui/skeleton";
import Loading from "@/components/dc-loading";
import { EmptyIcon } from "@/icons";
import { useTranslation } from "react-i18next";
import { useFilterContext } from "@/ui/head-bar/filter-context";

const paramsBuilder = (params) => {
  const nextParams = {};
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (Array.isArray(value)) {
      if (value.length > 0) nextParams[key] = value;
      return;
    }
    if (value === "" || value == null) return;
    nextParams[key] = value;
  });
  return nextParams;
};

export default function RestaurantList({
  loading = false,
  loadingMore = false,
  results = [],
  total = 0,
  isEmpty = false,
}) {
  const { BrowseStore } = useStores();
  const { setMapRange, cleanFilter } = useFilterContext();
  const { t } = useTranslation();
  const routerLocation = useLocation();
  const searchParams = useMemo(() => {
    const _search = routerLocation.search;
    void _search;
    const { q, date, seats, region, lang } = getQuery();
    return { q, date, seats, region, lang };
  }, [routerLocation.search]);
  const [ads, setAds] = useState([]);
  const [restaurantAds, setRestaurantAds] = useState([]);

  const showAllRestauants = () => {
    cleanFilter();
    setMapRange(null);
  };

  // 获取广告
  useRequest(
    () => {
      BrowseStore.getAds(searchParams.q || undefined, searchParams.region).then(
        (res) => {
          setAds(res || []);
        }
      );
      BrowseStore.getResAds({
        ...paramsBuilder({
          region: searchParams.region,
          collection_id: "",
          type: "restaurant",
          search_word: searchParams.q || "",
          lang: searchParams.lang,
        }),
      }).then((res) => setRestaurantAds(res || []));
    },
    {
      refreshDeps: [routerLocation.search],
    }
  );

  const restaurantsWithAds = useMemo(() => {
    const list = Array.isArray(results) ? results : [];
    const adList = Array.isArray(ads) ? ads : [];
    if (list.length === 0 || adList.length === 0) return list;

    return list.map((restaurant, index) => {
      const isTenth = (index + 1) % 10 === 0;
      if (!isTenth) return restaurant;

      const groupIndex = Math.floor(index / 10);
      const ad = adList[groupIndex % adList.length];
      if (!ad) return restaurant;

      return { ...(restaurant || {}), ad };
    });
  }, [results, ads]);

  if (loading) {
    return (
      <>
        <div className="expore-loading">
          {/* <Loading red={true} /> */}
          <div>{t("LOADING")}...</div>
        </div>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
      </>
    );
  }

  if (isEmpty) {
    return (
      <div className="expore-page-empty">
        <EmptyIcon />
        <p>{t("Header.No results")}</p>
        <div className="expore-page-empty-tip" onClick={showAllRestauants}>
          {t("Collection.showAllRestaurants")}
        </div>
      </div>
    );
  }

  return (
    <div className="explore-restaurant-list-wrapper">
      {total > 0 && <div className="sort-placeholder"></div>}
      {total > 0 && (
        <div className="expore-page-total">
          {t("Header.Restaurants", { count: total })}
        </div>
      )}
      {restaurantAds.length > 0 && (
        <div className="explore-restaurant-list">
          {restaurantAds.map((restaurant) => (
            <RestaurantCard
              restaurant={restaurant}
              isAd={true}
              key={restaurant?.id + "ad"}
            />
          ))}
        </div>
      )}
      {restaurantsWithAds.length > 0 && (
        <div className="explore-restaurant-list">
          {restaurantsWithAds.map((restaurant, index) => (
            <React.Fragment key={restaurant?.id ?? `idx-${index}`}>
              <RestaurantCard restaurant={restaurant} />
              {restaurant?.ad && <RestaurantAd ad={restaurant.ad} />}
            </React.Fragment>
          ))}
        </div>
      )}

      {loadingMore && (
        <div className="expore-loading">
          <Loading red={true} />
        </div>
      )}
    </div>
  );
}
